import HttpInterceptorManager from '../utils/http/interceptor'

class ExtensionsPlugin {

	constructor() {
		window.initExtensions = this.initExtensions.bind(this);
		this.extensions = {};
	}

	install(Vue, options) {

		options.extensionsPlugin = this;
		this.onRegisterExtension = options.onRegisterExtension;

		Vue.mixin({

			mounted() {

				/* Ge the extension name attribute of the component - if exists */
				let extensionName = this.$el.nodeType == 1 && this.$el.getAttribute('extension-name');
				if(extensionName) {

					let _this = this;

					setTimeout(()=> {

						/* Check if there are extension for this particular component */
						let extensions = options.extensionsPlugin.getExtension(extensionName);
						if(extensions) {

							/* Add to the extensionContext the props & data of the component */
							options.extensionContext.props = _this.$props;
							options.extensionContext.data  = _this.$data;

							/* For each extension code registered in for this extension - iterate and run */
							extensions.forEach(function(extension) {
								extension(options.extensionContext, _this.$el);
							});
						}
					});
				}
			}
		});
	}

	getExtension(extensionName) {
		return this.extensions[extensionName];
	}

	registerExtension(extensionName, extensionCode) {

		if(! this.extensions[extensionName]) {
			this.extensions[extensionName] = [];
		}

		if(extensionName == 'addHttpInterceptor') {
			let interceptor = extensionCode();
			HttpInterceptorManager.addInterceptor(interceptor);
		}

		/* Push the extension to the array - there may be more than one extension code for a particular extension */
		this.extensions[extensionName].push(extensionCode);
		if(this.onRegisterExtension && typeof this.onRegisterExtension == "function") {
			this.onRegisterExtension(extensionName, extensionCode);
		}
	}

	initExtensions(extensionName, extensionCallback) {

		extensionCallback(this);
	}

}

export default new ExtensionsPlugin();





// WEBPACK FOOTER //
// ../common/plugins/extensionsPlugin.js